import ApiService from '../../api/api';
import Vuex from 'vuex';
import Vue from 'vue';

const forEach = require('lodash/forEach');

Vue.use(Vuex);

export default {
    namespaced: true,
    state() {
        return {
           burials: []
        }
    },
    getters: {
        form: state => {
            return state.form;
        },
    },
    mutations: {
        setBurial(state, value) {
            state.burials = value;
        },
        removePage(state, item) {
            for (let i = 0; i < state.burials.data.length; i++) {
                if (state.burials.data[i].id === item.burial.id) {
                    for (let k = 0; k < state.burials.data[i].pages.length; k++) {
                        if (state.burials.data[i].pages[k].id === item.id) {
                            window.Vue.delete(state.burials.data[i].pages, k, item);
                        }
                    }
                }
            }
        },
        updateBurialMaxCount(state, item) {
            for (let i = 0; i < state.burials.data.length; i++) {
                if (state.burials.data[i].id === item.id) {
                    window.Vue.set(state.burials.data[i], 'max_count_pages', item.max_count_pages);
                }
            }
        },
    },
    actions: {
        index({state, commit, getters}, payload = {}) {
            return new Promise((resolve, reject) => {
                ApiService.get('/burial', payload)
                    .then((response) => {
                        commit('setBurial', response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        deletePage({state, commit, getters}, id) {
            return new Promise((resolve, reject) => {
                ApiService.delete('/page/'+ id)
                    .then((response) => {
                        commit('removePage',response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        updatePositions({state}, pages) {
            let items = [];

            forEach(pages, (page, position) => {
                items.push({id: page.id, position: position})
            });

            return new Promise((resolve, reject) => {
                ApiService.post('/page/update-position', {pages: items})
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        reduceMaxCountPages({state, commit, getters}, id){
            return new Promise((resolve, reject) => {
                ApiService.get('/burial/reduce-max-count-pages/'+ id)
                    .then((response) => {
                        commit('updateBurialMaxCount',response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        increaseMaxCountPages({state, commit, getters}, id){
            return new Promise((resolve, reject) => {
                ApiService.get('/burial/increase-max-count-pages/'+ id)
                    .then((response) => {
                        commit('updateBurialMaxCount',response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
    }
};


